import React from 'react';

const StatusBadge = ({ status, enabled = true }) => {
  if (!enabled) {
    return (
      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600">
        <span className="w-2 h-2 rounded-full bg-gray-400 dark:bg-gray-500 mr-2"></span>
        Disabled
      </span>
    );
  }

  if (status === 'up' || status === true) {
    return (
      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 border border-green-200 dark:border-green-700">
        <span className="w-2 h-2 rounded-full bg-green-500 dark:bg-green-400 mr-2 animate-pulse"></span>
        Up
      </span>
    );
  }

  return (
    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400 border border-red-200 dark:border-red-700">
      <span className="w-2 h-2 rounded-full bg-red-500 dark:bg-red-400 mr-2 animate-pulse"></span>
      Down
    </span>
  );
};

export default StatusBadge;
